import {
  GET_CARD_TYPES_FAIL,
  GET_CARD_TYPES_REQUEST,
  GET_CARD_TYPES_SUCCESS,
} from "src/constants/types";

export const cardTypeReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CARD_TYPES_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_CARD_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        cardTypes: actions.payload,
        error: "",
      };

    case GET_CARD_TYPES_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
